import GeoJSON from 'ol/format/GeoJSON';
import ImageCanvas from '@planet/maps/source/ImageCanvas';
import ImageLayer from '@planet/maps/layer/Image';
import React, {useMemo} from 'react';
import {bool, object} from 'prop-types';
import {getVectorContext} from 'ol/render';

import {CLIP_STYLE} from '@explorer/util/map-edit-styles';
import {getWatermark} from '@explorer/util/map';

const WatermarkLayer = ({clipGeometry, visible = false}) => {
  const {onPrerender, onPostrender} = useMemo(() => {
    const geometry = clipGeometry
      ? new GeoJSON().readGeometry(clipGeometry)
      : null;

    return {
      onPrerender: event => {
        const ctx = event.context;
        ctx.save();
        if (!geometry) {
          return false;
        }
        const vectorContext = getVectorContext(event);
        event.context.globalCompositeOperation = 'destination-in';
        vectorContext.setStyle(CLIP_STYLE);
        vectorContext.drawGeometry(geometry);
        ctx.clip();
        event.context.globalCompositeOperation = 'source-over';
      },
      onPostrender: event => {
        event.context.restore();
      },
    };
  }, [clipGeometry]);

  return (
    <ImageLayer
      visible={visible}
      onPrerender={onPrerender}
      onPostrender={onPostrender}
    >
      <ImageCanvas
        options={{
          canvasFunction: getWatermark,
          ratio: 1,
        }}
      />
    </ImageLayer>
  );
};

WatermarkLayer.propTypes = {
  visible: bool,
  clipGeometry: object,
};

export default WatermarkLayer;
